//React
import React from 'react';
import ReactDOM  from 'react-dom';
//Redux
import { Provider } from 'react-redux';
import store from './redux/Store';
//Componentes de la app
import App from './App';
import '@styles/normalize.css';
import 'bootstrap/dist/css/bootstrap.css';
import '@styles/global.css';
//babel
import "core-js/stable";
import "regenerator-runtime/runtime";
import './pages/Login/Login.css';
import {HashRouter as Router} from 'react-router-dom';
import {CookiesProvider} from "react-cookie";

//export const enableBanjercito = true;

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <CookiesProvider>
                <App/>
            </CookiesProvider>
        </Router>
    </Provider>,
    document.getElementById('app')
);
